module.exports = __webpack_public_path__ + "static/genrus-logo-41207b90fa7a24a985f89d134af42d3f.jpg";